var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "url(#paint0_linear_1598_1345)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4336 20.4168C10.98 20.4168 11.0571 20.2456 10.9007 19.8137L9.56689 15.4242L19.8336 9.3335",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4331 20.4168C11.7831 20.4168 11.9377 20.2568 12.1331 20.0668L13.9998 18.2517L11.6713 16.8477",
    fill: "#A9C9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6712 16.8477L17.3132 21.0161C17.957 21.3713 18.4217 21.1874 18.582 20.4183L20.8786 9.59599C21.1138 8.6533 20.5193 8.22574 19.9034 8.50537L6.41786 13.7053C5.49735 14.0745 5.50272 14.5881 6.25007 14.8169L9.71076 15.8971L17.7226 10.8425C18.1008 10.6131 18.448 10.7364 18.163 10.9893",
    fill: "url(#paint1_linear_1598_1345)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1598_1345",
    x1: 10.5014,
    y1: 1.1676,
    x2: 3.5014,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1598_1345",
    x1: 12.2473,
    y1: 14.8598,
    x2: 13.7432,
    y2: 19.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.5a6f184042059587638a2146aa0bc917.svg";
export { ForwardRef as ReactComponent };